import { Flex, Text } from "@chakra-ui/react";
import Input from "components/UI/atoms/Input";
import Select from "components/UI/atoms/Select";
import { useUI } from "providers/UIProvider";
import { InputGroup, InputRightElement, FormControl } from "@chakra-ui/react";

// const DUMB_DATA = [
//     { label: "10", value: 10 },
//     { label: "20", value: 20 },
//     { label: "35", value: 30 },
//     { label: "40", value: 40 },
//     { label: "50", value: 50 },
//     { label: "60", value: 60 },
//     { label: "70", value: 70 },
//     { label: "80", value: 80 },
//     { label: "90", value: 90 },
//     { label: "100", value: 100 },
//     { label: "110", value: 110 },
//     { label: "120", value: 120 },
// ];


interface IEditDetailsDiscount {
    discountPercent: any
    discount: number
    discountType: string | undefined | null
    discountTypesData: { value: number, label: string }[]
    handleDiscountPercent: (e: any) => void
    handleDiscountTypeId: (e: any) => void
    isDisabled?: boolean
}

const EditDetailsDiscount: React.FC<IEditDetailsDiscount> = ({
    discount,
    discountPercent,
    discountType,
    discountTypesData,
    handleDiscountPercent,
    handleDiscountTypeId,
    isDisabled }) => {

    const { T } = useUI();


    const selectStyles = {
        placeholder: (styles: any) => ({
            ...styles,
            color: "#08BA36",
            fontWeight: "bold"
        }),
        option: (baseStyles: any) => ({
            ...baseStyles,
            fontSize: "12px",

        }),
    };


    return (
        <Flex
            padding="16px 23px"
            justifyContent="space-between"
            borderBottom="1px solid #E9F2FD"
            width="100%"
            alignItems="center"
            height="50px"
        >
            <Flex alignItems="center" gap={3}>
                <Text fontSize="12px" fontWeight="medium">{T("bookings.discount")}:</Text>
                {/* <Text fontSize="14px" color="#08BA36" fontWeight="bold">{"TBC INSURANCE"}</Text> */}
                <Select
                    options={discountTypesData}
                    value={discountType}
                    placeholder={discountType ? discountType : "No Discount"}
                    maxMenuHeight={175}
                    styles={selectStyles}
                    onChange={handleDiscountTypeId}
                />
            </Flex>

            <Flex
                style={{
                    height: "32px",
                    width: "150px",
                    border: "1px solid #08BA36",
                    borderRadius: "100px",
                    justifyContent: "space-between",
                    padding: "0",
                }}>
                <Flex style={{
                    width: "50%",
                    alignItems: "center",
                    justifyContent: "center"
                }}>
                    <FormControl isDisabled={isDisabled}>
                        <InputGroup>
                            <Input
                                style={{
                                    border: "none",
                                    background: "transparent",
                                    height: "31px",
                                    textAlign: "right",
                                    paddingRight: "25px",
                                    fontWeight: "500",
                                    fontSize: "18px",
                                    opacity: isDisabled ? "30%" : "100%"
                                }}
                                stylePlaceholder={{ color: "#08BA36" }}
                                placeholder="0"
                                id="discountPercent"
                                name="discountPercent"
                                type="number"
                                onChange={handleDiscountPercent}
                                value={discountPercent}

                            />
                            <InputRightElement pointerEvents="none" width="30px" height="30px" zIndex="0" color="#08BA36" fontWeight="bold" opacity={isDisabled ? "30%" : "100%"}>%</InputRightElement>
                        </InputGroup>
                    </FormControl>

                </Flex>
                <Flex
                    alignItems="center"
                    justifyContent="center"
                    fontSize="18px"
                    color="white"
                    height="31px"
                    width="50%"
                    fontWeight="500"
                    borderRadius="14px"
                    backgroundColor="#08BA36"
                >
                    {discount}₾
                </Flex>
            </Flex>
        </Flex>
    )
};

export default EditDetailsDiscount;